"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _reactRedux = require("react-redux");

var _carSelectorGrid = require("@mmc/car-selector-grid");

var _mmcVehicleCodeUtility = _interopRequireWildcard(require("@mmc-tools/mmc-vehicle-code-utility"));

var _actionTypes = require("../../redux/actions/action-types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ObfuscateVehicleCode = new _mmcVehicleCodeUtility["default"](_mmcVehicleCodeUtility.VEHICLES_MAP);
var getVehicleByGuid = ObfuscateVehicleCode.getVehicleByGuid;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    clickEvent: function clickEvent(e) {
      var ctaUrl = e.currentTarget.getAttribute('data-destination');
      var urlParams = ctaUrl.split('?')[1].split('&');
      var code = getVehicleByGuid(urlParams[0].split('=')[1]);
      var year = urlParams[1].split('=')[1];
      dispatch({
        type: _actionTypes.SELECT_VEHICLE,
        vehicle: {
          code: code,
          year: year
        }
      });
    }
  };
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    data: {
      productTile: [].concat(ownProps.vehicles),
      selectedLabel: ownProps.vehicles[0].selectLabel
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_carSelectorGrid.CarSelectorGrid);

exports["default"] = _default;